export enum StorageSnsmVersion {
  V5 = "V5",
  V6 = "V6",
}
